// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-type1 {
  width: 400px;
  margin: 0 auto;
}

.list-type1 ol {
  counter-reset: li;
  list-style: none;
  /*list-style: decimal;*/
  font-size: 15px;
  font-family: "Raleway", sans-serif;
  padding: 0;
  margin-bottom: 4em;
}
.list-type1 ol ol {
  margin: 0 0 0 2em;
}

.list-type1 a {
  position: relative;
  display: block;
  padding: 0.4em 0.4em 0.4em 2em;
  /*padding: .4em;*/
  margin: 0.5em 0;
  background: #93c775;
  color: #000;
  text-decoration: none;
  border-radius: 10em;
  transition: all 0.2s ease-in-out;
}

.list-type1 a:hover {
  background: #d6d4d4;
  text-decoration: none;
  transform: scale(1.1);
}

.list-type1 a:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: #93c775;
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: 0.3em solid #fff;
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Bank/bankView.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EAGrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EAGjB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".list-type1 {\n  width: 400px;\n  margin: 0 auto;\n}\n\n.list-type1 ol {\n  counter-reset: li;\n  list-style: none;\n  /*list-style: decimal;*/\n  font-size: 15px;\n  font-family: \"Raleway\", sans-serif;\n  padding: 0;\n  margin-bottom: 4em;\n}\n.list-type1 ol ol {\n  margin: 0 0 0 2em;\n}\n\n.list-type1 a {\n  position: relative;\n  display: block;\n  padding: 0.4em 0.4em 0.4em 2em;\n  /*padding: .4em;*/\n  margin: 0.5em 0;\n  background: #93c775;\n  color: #000;\n  text-decoration: none;\n  -moz-border-radius: 0.3em;\n  -webkit-border-radius: 0.3em;\n  border-radius: 10em;\n  transition: all 0.2s ease-in-out;\n}\n\n.list-type1 a:hover {\n  background: #d6d4d4;\n  text-decoration: none;\n  transform: scale(1.1);\n}\n\n.list-type1 a:before {\n  content: counter(li);\n  counter-increment: li;\n  position: absolute;\n  left: -1.3em;\n  top: 50%;\n  margin-top: -1.3em;\n  background: #93c775;\n  height: 2em;\n  width: 2em;\n  line-height: 2em;\n  border: 0.3em solid #fff;\n  text-align: center;\n  font-weight: bold;\n  -moz-border-radius: 2em;\n  -webkit-border-radius: 2em;\n  border-radius: 2em;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
